import { render } from "./FormWritten.vue?vue&type=template&id=0e659653&scoped=true"
import script from "./FormWritten.vue?vue&type=script&lang=js"
export * from "./FormWritten.vue?vue&type=script&lang=js"

import "./FormWritten.vue?vue&type=style&index=0&id=0e659653&scoped=true&lang=css"

import exportComponent from "D:\\服务器\\web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e659653"]])

export default __exports__